// Swaps the Poppins preload link to a stylesheet once loaded.
// Extracted from an inline onload handler to comply with strict
// `script-src 'self'` CSP (no inline script execution). See
// docs/architecture/security-headers.md and UX-018.
const link = document.getElementById("poppins-font") as HTMLLinkElement | null;
if (link) {
  link.rel = "stylesheet";
}
